import { isClientSide } from "@helper/utils";
import {
  SCREEN_LG,
  SCREEN_MD,
  SCREEN_SM,
  SCREEN_XL,
  SCREEN_XMD,
} from "@hooks/useWindowSize/constants";
import { useEffect, useState } from "react";
/**
 * @returns {object} The current window size state.
 */
function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: 0,
    height: 0,
  });

  const isScreenXL = windowSize.width >= SCREEN_XL;
  const isScreenLG = windowSize.width >= SCREEN_LG;
  const isScreenXMD = windowSize.width >= SCREEN_XMD;
  const isScreenMD = windowSize.width >= SCREEN_MD;
  const isScreenSM = windowSize.width >= SCREEN_SM;
  const isScreenBelowSM = windowSize.width < SCREEN_SM;

  useEffect(() => {
    // useEffect is only called client-side.
    // To prevent SSR issues, we check if window is defined.
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    if (isClientSide) {
      window.addEventListener("resize", handleResize);
      handleResize();
    }

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return {
    isScreenXL,
    isScreenLG,
    isScreenXMD,
    isScreenMD,
    isScreenSM,
    isScreenBelowSM,
  };
}

export { useWindowSize };
